export const FONTS = {
  ARIMO: { name: 'Arimo', type: 'sans-serif' },
  DM_SANS: { name: 'DM Sans', type: 'sans-serif' },
  ROBOTO_MONO: { name: 'Roboto Mono', type: 'monospace' },
};
